module.exports = "varying vec2 vUv;\r\n\r\nvoid main() {\r\n    vUv = uv;\r\n    gl_Position = vec4(position.xy * 2.0, .01, 1.0);\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/shaders/backgrounds/polka.vert.glsl
// module id = 35
// module chunks = 0